import React, { useState } from "react";
import styled from "styled-components";
import ImportList from "../Import/ImportList";
import Checkbox from "modules/Common/Components/Checkbox";
import Input from "modules/Common/Components/Input";
import Cross from "../../../../assets/img/icons/cross.svg";
import { Link } from "react-router-dom";
import { removeGillRoyIcon } from "utils";
import { useSelector } from "react-redux";
import { RootState } from "store";

interface AppProps {
  setShowImportListAsider?: any;
  setShowImportListMapAsider?: any;
  fileName: string;
  setFileName: any;
  inputListName: string;
  setInputListName: any;
  fieldsMapping?: any;
  setFieldsMapping?: any;
  nonMappedFields?: string[];
  setNonMappedFields?: any;
  selectedFile: File;
  setSelectedFile: any;
  handleCancelImport?: any;
  error: any;
  setError: any;
}

const FloatingPopoverImport: React.FC<AppProps> = ({
  setShowImportListAsider,
  setShowImportListMapAsider,
  fileName,
  setFileName,
  inputListName,
  setInputListName,
  fieldsMapping,
  setFieldsMapping,
  nonMappedFields,
  setNonMappedFields,
  selectedFile,
  setSelectedFile,
  handleCancelImport,
  error,
  setError,
}) => {
  const [showListNameInput, setShowListNameInput] = useState("d-none");
  const isSelectionedEmail = useSelector((state: RootState) => state.dragDrop.gillRoyMoveUp);

  const handleOnClickCheckbox = (e: any) => {
    if (showListNameInput === "") {
      setShowListNameInput("d-none");
    } else {
      setShowListNameInput("");
    }
  };

  const handleInputChange = (e: any) => {
    let value = e.target.value;
    if (value.includes(",")) {
      setError("',' is not allowed in list names.");
    } else {
      setInputListName(value?.replace(",", ""));
      if (error) setError("");
    }
  };


  const handleCancelImportFunc = () => {
    if (handleCancelImport)
      handleCancelImport()
    else setShowImportListAsider(false)
    if (!window.location.pathname.includes("editionedit") && !isSelectionedEmail)
      removeGillRoyIcon()
  }

  return (
    <Wrapper>
      <div>
        <h2>
          Import a<br />
          contact list
        </h2>
        <span
          className="cross"
          onClick={handleCancelImportFunc}
        >
          <img src={Cross} />
        </span>
        <p>
          To get the most out of xiQ’s Workbench, you’ll need contacts to send emails to. To get started, please
          upload an .xlsx or .csv file with your contacts. We’ll import them and take care of the rest.
        </p>
        <p>
          Download example file here:{" "}
          <Link to="/files/sample_file.xlsx" target="_blank" download>
            <span className="green">XLS </span>
          </Link>
          <span style={{ color: "#5E7079" }}>or</span>
          <Link to="/files/sample_file.csv" target="_blank" download>
            <span className="green"> CSV</span>
          </Link>
        </p>
        <div className="import-name-checkbox-text">
          <label>
            <Checkbox onClick={(e: any) => handleOnClickCheckbox(e)} /> Create a new list from import
          </label>
        </div>
        <div className="import-name">
          <Input
            placeholder="Give your list a name…"
            value={inputListName}
            onChange={handleInputChange}
            className={showListNameInput}
            error={error}
          />
        </div>
      </div>
      <div className="import-box">
        <ImportList
          setShowImportListAsider={setShowImportListAsider}
          setShowImportListMapAsider={setShowImportListMapAsider}
          fileName={fileName}
          setFileName={setFileName}
          fieldsMapping={fieldsMapping}
          setFieldsMapping={setFieldsMapping}
          nonMappedFields={nonMappedFields}
          setNonMappedFields={setNonMappedFields}
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
        />
      </div>
    </Wrapper>
  );
};

export default FloatingPopoverImport;

const Wrapper = styled.div`
  .import-name-checkbox-text {
    font-family: "robotoregular";
    color: #5e7079;
    font-size: 16px;
    text-align: left;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
    }
  }
  > div {
    padding: 50px 35px 0 35px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding: 25px 35px 0 35px;
      margin-bottom: -5px;
    }
    h2 {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 28px !important;
        line-height: 28px !important;
      }
    }
    label {
      cursor: pointer;
      line-height: 16px;
      > div {
        margin-top: 0;
      }
    }
    .import-name {
      margin: 5px 0;
      label {
        margin: 0;
      }
    }
  }
  .import-box {
    padding: 0px 34px 20px 34px;
    margin-bottom: 45px;
    img,
    h4 {
      float: left;
    }
    img {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 35px;
        margin-right: 12px;
      }
    }
    h4 {
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 15px;
      }
    }
    p {
      word-break: break-word;
    }
  }
  .cross {
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 20px;
  }
  .cross > img {
    width: auto;
  }
`;
